import { Link } from 'react-router-dom';
import { CaretRight, CreditCard, Wallet } from '@phosphor-icons/react';

import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

/** .pen `ds/button/detail-link`. */
function DetailLink({ to, label, icon: Icon, chipClassName }) {
  return (
    <Link
      to={to}
      className="flex min-w-0 flex-1 items-center gap-space-3 rounded-ds-lg border border-border bg-card px-space-4 py-space-3 transition hover:border-sage-300 dark:hover:border-sage-600"
    >
      <span
        className={cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-ds-md',
          chipClassName,
        )}
      >
        <Icon className="h-4 w-4" aria-hidden />
      </span>
      <span className="type-body min-w-0 flex-1 truncate font-semibold text-foreground">
        {label}
      </span>
      <CaretRight className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
    </Link>
  );
}

export function PatrimonioDetailLinks({ stacked = false, className }) {
  return (
    <div className={cn('flex min-w-0 gap-space-3', stacked ? 'flex-col' : 'flex-row', className)}>
      <DetailLink
        to={paths.ativos}
        label={pt.patrimonio.detailLinks.assets}
        icon={Wallet}
        chipClassName="bg-sage-tint text-sage-on-tint"
      />
      <DetailLink
        to={paths.dividas}
        label={pt.patrimonio.detailLinks.debts}
        icon={CreditCard}
        chipClassName="bg-rose-100 text-rose-800 dark:bg-rose-950/40 dark:text-rose-300"
      />
    </div>
  );
}
